import * as React from 'react';
import { Input, Button, Icon, Layout, Dropdown } from 'antd';
import ComponentBasic from 'kts-scaffold-framework/component/ComponentBasic';
import ChatPanelProps from './ChatPanelProps';
import ChatPanelState from './ChatPanelState';
import UIEnter from './UI.Enter';

const css = require('./index.scss');
const { TextArea } = Input;
const { Header, Footer, Sider, Content } = Layout;

/** 聊天面板组件 */
export default class ChatPanel extends ComponentBasic<ChatPanelProps, ChatPanelState> {

    state = new ChatPanelState();

    /** 输入组件 */
    private enter: UIEnter;

    /** 构造函数 */
    constructor(props: ChatPanelProps) {
        super(props);
        this.state.chatList = this.props.defaultChatList ? this.props.defaultChatList.slice() : [];
    }

    /** 设置聊天内容列表 */
    public setChatList(chatList: JSX.Element[]): Promise<void> {
        return new Promise<void>((resolve: () => void) => {
            this.setState({ chatList: chatList }, resolve);
        });
    }

    /** 获取聊天内容列表 */
    public getChatList(): JSX.Element[] {
        return this.state.chatList;
    }

    /** 添加了聊天内容 */
    public addChat(chat: JSX.Element) {
        const chatList = this.state.chatList.slice();
        chatList.push(chat);
        this.setState({ chatList: chatList }, this.scrollBottom);
    }

    /** 设置输入聊天内容 */
    public setText = (value: string): Promise<void> => {
        return new Promise<void>((resolve: () => void) => {
            this.enter.setState({ text: value }, resolve);
        });
    }

    /** 获取输入聊天内容 */
    public getText = (): string => {
        return this.enter.state.text;
    }

    componentDidMount() {
        this.scrollBottom();
    }

    render() {
        const { title } = this.props;
        return (
            <Layout className={css['chat-panel']}>
                {
                    title &&
                    <Header className={css.title}>
                        {title}
                    </Header>
                }

                <Content id="kts-chat-panel-content" className={css.content}>
                    {this.state.chatList}
                </Content>

                <UIEnter
                    ref={e => { this.enter = e; }}
                    defaultText={this.props.defaultText}
                    onChangeText={this.onChangeTextAreaHandler}
                    onSend={this.onClickSendButtonHandler}
                />
            </Layout>
        );
    }

    /** 滚动条到底部 */
    private scrollBottom = () => {
        const cpc = window.document.querySelector('#kts-chat-panel-content');
        cpc.scrollTop = cpc.scrollHeight;
    }

    /** 文本改变事件 */
    private onChangeTextAreaHandler = (text: string) => {
        if (this.props.onChangeText) {
            this.props.onChangeText(this, text);
        }
    }

    /** 点击了发送 */
    private onClickSendButtonHandler = (text: string) => {
        if (this.props.onSend) {
            this.props.onSend(this, text);
        }
    }
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/components/ChatPanel/index.tsx